(() => {
  const DAY = 86400000;
  // Use PKT independently of the customer's device timezone.
  function calculate(now, cutoff, min, max) {
    const pkt = new Date(now + 5 * 3600000);
    const today = Date.UTC(pkt.getUTCFullYear(), pkt.getUTCMonth(), pkt.getUTCDate());
    let dispatch = today;
    if (pkt.getUTCHours() >= cutoff) dispatch += DAY;
    while (new Date(dispatch).getUTCDay() === 0) dispatch += DAY;
    function addWorking(date, count) {
      while (count > 0) { date += DAY; if (new Date(date).getUTCDay() !== 0) count--; }
      return date;
    }
    return {today, dispatch, earliest:addWorking(dispatch,min), latest:addWorking(dispatch,max), remaining:Math.max(0, Math.ceil((dispatch + cutoff*3600000 - 5*3600000 - now)/60000))};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {calculate};
  if (typeof customElements === 'undefined' || customElements.get('flaay-shipping-timeline')) return;
  customElements.define('flaay-shipping-timeline', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = setInterval(() => this.update(), 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      if (!this.querySelector('[data-intro]')) return;
      const cutoff = Math.min(23,Math.max(0,Number(this.dataset.cutoff)||0));
      const min = Math.max(1,Number(this.dataset.min)||3);
      const max = Math.max(min,Number(this.dataset.max)||4);
      const result = calculate(Date.now(),cutoff,min,max);
      const format = d => new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',timeZone:'UTC'}).format(new Date(d));
      const hours = Math.floor(result.remaining/60), mins = result.remaining%60;
      const duration = `${hours ? hours+' hrs ' : ''}${mins} mins`;
      const intro = this.querySelector('[data-intro]');
      intro.replaceChildren(document.createTextNode('If you order within '));
      const strong = document.createElement('strong'); strong.textContent = duration; intro.append(strong);
      intro.append(document.createTextNode(result.dispatch===result.today ? ' — dispatch today' : ` — dispatch ${format(result.dispatch)}`));
      this.querySelector('[data-ordered]').textContent = 'Today';
      this.querySelector('[data-shipped]').textContent = result.dispatch===result.today ? 'Today' : format(result.dispatch);
      this.querySelector('[data-delivered]').textContent = format(result.earliest) + (result.latest!==result.earliest ? ' – '+format(result.latest) : '');
      this.querySelector('[data-cutoff-label]').textContent = `${cutoff%12||12} ${cutoff>=12?'PM':'AM'}`;
    }
  });
})();
